import { Autocomplete, Field, SearchField } from 'components/commons';
import React, { useCallback } from 'react';
import styles from './customer-account-filter.module.scss';

import SelectProduct from 'components/field/select-product/select-product';

const CustomerClaimsFilter = ({
  filterState,
  onStatusChange,
  onSearchChange,
  onProductChange,
  onSearch,
  onYearChange,
  onMonthChange
}) => {
  // const onStatusChangeCb = useCallback(
  //   (name, { value }) => {
  //     if (onStatusChange) return onStatusChange(value || 'all');
  //   },
  //   [onStatusChange]
  // );

  const onMonthChangeCb = useCallback(
    (name, { value }) => {
      if (onMonthChange) return onMonthChange(value || 'all');
    },
    [onMonthChange]
  );

  const onYearChangeCb = useCallback(
    (name, { value }) => {
      if (onYearChange) return onYearChange(value || 'all');
    },
    [onYearChange]
  );

  const onProductChangeCb = useCallback(
    (name, { label, value }) => {
      if (onProductChange) return onProductChange({ label, value });
    },
    [onProductChange]
  );

  const onSearchChangeCb = useCallback(
    (name, { value }) => {
      if (onSearchChange) {
        return onSearchChange('searchKey', { value });
      }
    },
    [onSearchChange]
  );

  const onSearchCb = useCallback(
    (searchKey) => {
      if (onSearch) {
        return onSearch(searchKey);
      }
    },
    [onSearch]
  );

  return (
    <div className={styles.filter}>
      <div className={styles.filterContent}>
        <Field className={styles.status} label="Month">
          <Autocomplete
            name="month"
            value={filterState.month}
            options={[
              { label: 'January', value: '01' },
              { label: 'February', value: '02' },
              { label: 'March', value: '03' },
              { label: 'April', value: '04' },
              { label: 'May', value: '05' },
              { label: 'June', value: '06' },
              { label: 'July', value: '07' },
              { label: 'August', value: '08' },
              { label: 'September', value: '09' },
              { label: 'October', value: '10' },
              { label: 'November', value: '11' },
              { label: 'December', value: '12' }
            ]}
            onChange={onMonthChangeCb}
          />
        </Field>
        <Field className={styles.status} label="Year">
          <Autocomplete
            name="year"
            value={filterState.year}
            options={[
              { label: '2025', value: '2025' },
              { label: '2026', value: '2026' },
              { label: '2027', value: '2027' }
            ]}
            onChange={onYearChangeCb}
          />
        </Field>
        <Field className={styles.status} label="Product">
          <SelectProduct
            {...filterState?.product}
            onChange={onProductChangeCb}
            placeholder="All"
            hasAll
            value={filterState.product}
          />
        </Field>

        <Field className={styles.search} label="Search">
          <SearchField
            placeholder={'Customer Account Number'}
            value={filterState.searchKey}
            onChange={onSearchChangeCb}
            onEnter={onSearchCb}
            restrict={false}
          />
        </Field>
      </div>
    </div>
  );
};

export default CustomerClaimsFilter;
